
export const getNameFromEmail = (email) => {
    var name = email.substring(0, email.lastIndexOf("@"));
    return name;
}